
import { supabase } from '@/integrations/supabase/client';
import { shouldSendNotification } from '@/utils/notificationFrequency';
import type { NotificationFrequency } from '@/utils/notificationFrequency';

export const useDocumentNotifier = () => {
  const createDocumentNotification = async (
    userId: string, 
    status: 'verified' | 'rejected',
    notes?: string,
    frequency: NotificationFrequency = 'immediate'
  ) => {
    // Get user's last notification
    const { data: lastNotification } = await supabase
      .from('notifications')
      .select('created_at')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .limit(1)
      .single();

    const lastNotificationTime = lastNotification?.created_at 
      ? new Date(lastNotification.created_at)
      : undefined;

    // Check if we should send based on frequency
    if (!shouldSendNotification(frequency, lastNotificationTime)) {
      console.log('Skipping notification based on frequency settings');
      return;
    }

    // Use the correct notification types from the database
    const notificationType = status === 'verified' 
      ? 'document_verified' 
      : 'document_rejected';
      
    const notification = {
      user_id: userId,
      type: notificationType,
      title: status === 'verified' 
        ? 'Identity Verification Approved' 
        : 'Identity Verification Rejected',
      body: status === 'verified'
        ? 'Your identity document has been approved. Thank you for completing the verification process.'
        : `Your identity document has been rejected. ${notes ? `Reason: ${notes}` : 'Please submit a new document or contact support for assistance.'}`,
      link: '/profile',
      seen: false
    };
    
    const { error: notificationError } = await supabase
      .from('notifications')
      .insert([notification]);
    
    if (notificationError) {
      console.error('Error creating notification:', notificationError);
    }
  };

  return { createDocumentNotification };
};
